import React from "react";
import "./PersonalProjects.css";
import Barvistas1 from "../../assets/barvistas1.png";
import Barvistas2 from "../../assets/barvistas2.png";
import Barvistas3 from "../../assets/barvistas3.png";
import Barvistas4 from "../../assets/barvistas4.png";

const PersonalProjects = () => {
  return (
    <section id="personal-projects" className="personal-projects">
      <h2>Personal Projects</h2>

      <div className="project">
        <h3 className="project__title">Barvistas (iOS app)</h3>
        <p className="project__subtitle">
          Discover exclusive bars with breathtaking city views across London, Madrid, New York, and Tokyo
        </p>

        <div className="project__content">
          <div className="project__section">
            <h4>Key Features</h4>
            <ul>
              <li>Map-based discovery using Apple Maps</li>
              <li>Dietary filters (Vegan, Vegetarian, Halal, Celiac)</li>
              <li>User rating system and descriptive bar profiles</li>
              <li>StoreKit 2 integration for in-app donations</li>
            </ul>
          </div>

          <div className="project__section">
            <h4>Technologies</h4>
            <ul>
              <li>SwiftUI</li>
              <li>Apple Maps / CoreLocation</li>
              <li>StoreKit 2</li>
              <li>Google Mobile Ads</li>
            </ul>
          </div>
        </div>

        <div className="project__screenshots">
          <img src={Barvistas1} alt="Barvistas Screenshot 1" />
          <img src={Barvistas2} alt="Barvistas Screenshot 2" />
          <img src={Barvistas3} alt="Barvistas Screenshot 3" />
          <img src={Barvistas4} alt="Barvistas Screenshot 4" />
        </div>

        <a
          href="https://apps.apple.com/gb/app/barvistas/id6748584789"
          target="_blank"
          rel="noopener noreferrer"
          className="project__link"
        >
          View on the App Store
        </a>
      </div>
    </section>
  );
};

export default PersonalProjects;
